import React from 'react';
import { motion } from 'framer-motion';
import { Link } from 'react-router-dom';
import BuyButtons from '../components/BuyButtons';
import * as FiIcons from 'react-icons/fi';

const { FiArrowRight, FiGlobe } = FiIcons;

const values = [
  {
    title: 'Empathy First',
    desc: 'Every word in this book is written from a place of deep empathy for both men and the women who love them.',
  },
  {
    title: 'Truth Over Comfort',
    desc: "Andrei doesn't offer easy platitudes. He offers honest, sometimes challenging truths that actually create change.",
  },
  {
    title: 'Practical Wisdom',
    desc: 'The insights in this book are designed to be applied immediately, not just contemplated.',
  },
];

const AboutPage = () => (
  <div className="pt-28">
    {/* Hero */}
    <section className="py-20 bg-gradient-to-b from-amber-50 to-white">
      <div className="max-w-6xl mx-auto px-6">
        <div className="grid md:grid-cols-2 gap-16 items-center">
          <motion.div
            initial={{ opacity: 0, scale: 0.95 }}
            animate={{ opacity: 1, scale: 1 }}
            transition={{ duration: 0.8 }}
            className="relative"
          >
            <div className="absolute -inset-4 bg-brand-accent/10 rounded-3xl blur-xl" />
            <img
              src="https://media-manager-c.questera.ai/greta-media/ae05bbc051fb17176d2c348bf77438a7a494626431a725f22ebe70ac4579d949c16512ea83019a888cf26e0e50680ce7/images/aW1hZ2UvanBlZw==/91ab01df2fc17bd64fc03588a793bcb6.jpg"
              alt="Andrei Ciomîrtan"
              className="relative rounded-3xl w-full object-cover aspect-[4/5] shadow-2xl"
            />
          </motion.div>

          <motion.div
            initial={{ opacity: 0, x: 30 }}
            animate={{ opacity: 1, x: 0 }}
            transition={{ duration: 0.8, delay: 0.2 }}
          >
            <span className="text-brand-accent font-semibold tracking-widest uppercase text-xs">The Author</span>
            <h1 className="text-5xl font-serif font-bold text-brand-dark mt-3 mb-6 leading-tight">
              Andrei Ciomîrtan
            </h1>
            <p className="text-xl text-slate-500 mb-6 font-light italic">Author - Blogger - Good Man in Relationship</p>

            <div className="space-y-4 text-slate-600 leading-relaxed">
              <p>
                Andrei Ciomîrtan is a relationship author and coach whose work centers on one profound question: why do good men and the women who love them so often fail to reach each other?
              </p>
              <p>
                Drawing on years of coaching experience, personal study, and deep reflection on his own journey as a man, Andrei writes with rare candor and compassion. His approach rejects the simplistic narratives that dominate popular relationship culture and instead goes deeper — into the emotional architecture of men, the unspoken contracts of love, and the practical bridges that can span the gap.
              </p>
              <p>
                <em>How to Love a Good Man</em> is his most personal and powerful work — a book he says he had to write, because no one else had written it quite this way.
              </p>
            </div>

            <a
              href="https://ciomirtan.com"
              target="_blank"
              rel="noopener noreferrer"
              className="inline-flex items-center gap-2 mt-8 text-brand-accent font-semibold hover:gap-4 transition-all"
            >
              <FiGlobe size={16} /> Visit ciomirtan.com <FiArrowRight size={16} />
            </a>
          </motion.div>
        </div>
      </div>
    </section>

    {/* Values */}
    <section className="py-20 bg-white">
      <div className="max-w-5xl mx-auto px-6">
        <div className="text-center mb-12">
          <h2 className="text-4xl font-serif font-bold text-brand-dark">What Drives This Work</h2>
        </div>
        <div className="grid md:grid-cols-3 gap-8">
          {values.map((v, i) => (
            <motion.div
              key={i}
              initial={{ opacity: 0, y: 20 }}
              whileInView={{ opacity: 1, y: 0 }}
              viewport={{ once: true }}
              transition={{ duration: 0.5, delay: i * 0.1 }}
              className="text-center p-8 bg-amber-50 rounded-2xl border border-amber-100"
            >
              <h3 className="font-serif font-bold text-xl text-brand-dark mb-3">{v.title}</h3>
              <p className="text-slate-600 leading-relaxed">{v.desc}</p>
            </motion.div>
          ))}
        </div>
      </div>
    </section>

    {/* CTA */}
    <section className="py-20 bg-slate-900 text-white text-center">
      <div className="max-w-2xl mx-auto px-6">
        <h2 className="text-4xl font-serif font-bold mb-5">Read Andrei's Most Important Work</h2>
        <p className="text-slate-400 text-lg mb-10">Available worldwide in three formats.</p>
        <BuyButtons />
      </div>
    </section>
  </div>
);

export default AboutPage;